module.exports = __webpack_public_path__ + "assets/img/bg-hero.29fdaa332a31008b727fbf6fd762be16.svg";